import {call, put} from "redux-saga/effects"

import api from "../../services/ApiService"
import {LoginSuccessfulCreators as Creators} from "./redux"
import {AppCreators} from "../App/redux"
import {i18n, readableErrors} from "../../utils"

export default function* router(_dispatch, _action) {
  // tracking
  yield put(
    AppCreators.trackingAdd({
      event: "mtm.virtualPageView",
      section: "login-successful",
      document_title: i18n.t("Login erfolgreich")
    })
  )

  // content request
  yield put(Creators.request("login-successful"))

  try {
    const contentResponse = yield call(
      api.getPageContentBySlug,
      "login-successful"
    )

    yield put(Creators.success(contentResponse))
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/LoginSuccessful/sagas.js